import { ButtonBase, IconButton, MenuItem } from "@material-ui/core";
import styles from "./Styles.module.css";
import CustomSelectField from "../../components/FormFields/SelectField/SelectField.component";
import CustomTextField from "../../components/FormFields/TextField/TextField.component";
import TotalSum from "./Components/TotalSum";
import { Delete, Edit } from "@material-ui/icons";
import SalaryCalculatorHook from "./SalaryCalculator.hook";

const SalaryCalculator = ({ location }) => {
  const {
    form,
    errorData,
    listData,
    changeTextData,
    onBlurHandler,
    removeError,
    filteredCadres,
    empFlag,
    isCorporateHR,
    showExtraFields,
    handleProfileView,
  } = SalaryCalculatorHook({ location });
  const getSumValue = (...numbers) => {
    return numbers
      ? numbers.reduce((sum, value) => {
        if (value) {
          return sum + parseFloat(value);
        }
        return sum;
      }, 0)
      : "-";
  };
  return (
    <div>
      <div className={styles.outerFlex}></div>
      <div className={"plainPaper"}>
        <div>
          <ButtonBase>
            <span className={styles.title}>Salary Calculator</span>
          </ButtonBase>
          <div className={styles.newLines} />
        </div>
        <div className={styles.des}>
          Select below mention details to calculate the salary
        </div>

        <div className={"formFlex"} id={styles.mobileResponsiveData}>
          <div className={"formGroup"}>
            <CustomSelectField
              isError={errorData?.location_id}
              errorText={errorData?.location_id}
              label={"Location"}
              value={form?.location_id}
              handleChange={(value) => {
                changeTextData(value, "location_id");
              }}
            >
              {listData?.LOCATION_DEPARTMENTS?.map((dT) => {
                return (
                  <MenuItem value={dT?.id} key={dT?.id}>
                    {dT?.name}
                  </MenuItem>
                );
              })}
            </CustomSelectField>
          </div>
          <div className={"formGroup"}>
            <CustomSelectField
              isError={errorData?.designation_id}
              errorText={errorData?.designation_id}
              label={"Designation"}
              value={form?.designation_id}
              handleChange={(value) => {
                changeTextData(value, "designation_id");
              }}
            >
              {listData?.DESIGNATIONS?.map((dT) => {
                return (
                  <MenuItem value={dT?.id} key={dT?.id}>
                    {dT?.name}
                  </MenuItem>
                );
              })}
            </CustomSelectField>
          </div>
        </div>
        <div className={"formFlex"} id={styles.mobileResponsiveData}>
          <div className={"formGroup"}>
            <CustomSelectField
              isError={errorData?.grade_id}
              errorText={errorData?.grade_id}
              label={"Grade"}
              value={form?.grade_id}
              handleChange={(value) => {
                changeTextData(value, "grade_id");
              }}
            >
              {listData?.GRADES?.map((dT) => {
                return (
                  <MenuItem value={dT?.id} key={dT?.id}>
                    {dT?.code}
                  </MenuItem>
                );
              })}
            </CustomSelectField>
          </div>
          <div className={"formGroup"}>
            <CustomSelectField
              isError={errorData?.cadre_id}
              errorText={errorData?.cadre_id}
              label={"Cadre"}
              value={form?.cadre_id}
              handleChange={(value) => {
                changeTextData(value, "cadre_id");
              }}
            >
              {filteredCadres?.map((dT) => {
                return (
                  <MenuItem value={dT?.id} key={dT?.id}>
                    {dT?.name}
                  </MenuItem>
                );
              })}
            </CustomSelectField>
          </div>
        </div>

        <div className={"formFlex"} id={styles.mobileResponsiveData}>
          <div className={"formGroup"}>
            <CustomTextField
              type={"number"}
              disabled={empFlag ? true : false}
              inputProps={{ min: 0 }}
              isError={errorData?.incremental_gross_salary}
              errorText={errorData?.incremental_gross_salary}
              label={"Incremental Gross Salary"}
              value={form?.incremental_gross_salary}
              onTextChange={(text) => {
                changeTextData(text, "incremental_gross_salary");
              }}
              onBlur={() => {
                onBlurHandler("incremental_gross_salary");
              }}
            />
          </div>
          <div className={"formGroup"}>
            <CustomTextField
              disabled={
                empFlag || form?.is_car_component_manual === "NO"
                  ? true
                  : false
              }
              type={"number"}
              isError={errorData?.car_component}
              errorText={errorData?.car_component}
              label={"Car Component"}
              value={form?.car_component}
              onTextChange={(text) => {
                changeTextData(text, "car_component");
              }}
              onBlur={() => {
                onBlurHandler("car_component");
              }}
            />
          </div>
        </div>
      </div>
      {showExtraFields && (
        <>
          <div className={"plainPaper"}>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>Employee Monthly Salary Details</div>
              </h4>
            </div>

            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  type={"number"}
                  disabled={empFlag ? true : false}
                  inputProps={{ min: 0 }}
                  isError={errorData?.incremental_gross_salary}
                  errorText={errorData?.incremental_gross_salary}
                  label={"Incremental Gross Salary"}
                  value={form?.incremental_gross_salary}
                  onTextChange={(text) => {
                    changeTextData(text, "incremental_gross_salary");
                  }}
                  onBlur={() => {
                    onBlurHandler("incremental_gross_salary");
                  }}
                />
              </div>
              <div style={{ display: "flex", flex: "1" }}>
                <div className={"formGroup"}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_car_component_manual === "NO"
                        ? true
                        : false
                    }
                    type={"number"}
                    isError={errorData?.car_component}
                    errorText={errorData?.car_component}
                    label={"Car Component"}
                    value={form?.car_component}
                    onTextChange={(text) => {
                      changeTextData(text, "car_component");
                    }}
                    onBlur={() => {
                      onBlurHandler("car_component");
                    }}
                  />
                </div>
                <div className={styles.editBtnWrap}>
                  <IconButton
                    className={"tableActionBtnEdit"}
                    color="secondary"
                    disabled={empFlag ? true : false}
                    onClick={() => {
                      changeTextData("YES", "is_car_component_manual");
                    }}
                  >
                    <Edit fontSize={"small"} />
                  </IconButton>
                </div>
                <div className={styles.editBtnWrap}>
                  <IconButton
                    className={"tableActionBtnEdit"}
                    color="secondary"
                    disabled={empFlag ? true : false}
                    onClick={() => {
                      changeTextData("NO", "is_car_component_manual");
                    }}
                  >
                    <Delete fontSize={"small"} />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className={"formFlex"}>
              <TotalSum
                firstName="Incremental Gross Salary + Car Component: "
                firstAmount={getSumValue(form?.gross)}
              />
            </div>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>Part A - Earnings 1</div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div style={{ display: "flex", flex: "1" }}>
                <div className={"formGroup"}>
                  <CustomTextField
                    type={"number"}
                    disabled={form?.is_basic_salary_manual === "NO" ? true : false}
                    isError={errorData?.basic_salary}
                    errorText={errorData?.basic_salary}
                    label={"Basic"}
                    value={form?.basic_salary}
                    onTextChange={(text) => {
                      changeTextData(text, "basic_salary");
                    }}
                    onBlur={() => {
                      onBlurHandler("basic_salary");
                    }}
                  />
                </div>
                <div className={styles.editBtnWrap}>
                  <IconButton
                    // disabled={role !== "CORPORATE_HR"}
                    disabled={!isCorporateHR}
                    className={"tableActionBtnEdit"}
                    color="secondary"
                    onClick={() => {
                      changeTextData("YES", "is_basic_salary_manual");
                    }}
                  >
                    <Edit fontSize={"small"} />
                  </IconButton>
                </div>
                <div className={styles.editBtnWrap}>
                  <IconButton
                    // disabled={role !== "CORPORATE_HR"}
                    disabled={!isCorporateHR}
                    className={"tableActionBtnEdit"}
                    color="secondary"
                    onClick={() => {
                      changeTextData("NO", "is_basic_salary_manual");
                    }}
                  >
                    <Delete fontSize={"small"} />
                  </IconButton>
                </div>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.hra}
                  errorText={errorData?.hra}
                  label={"HRA"}
                  value={form?.hra}
                  onTextChange={(text) => {
                    changeTextData(text, "hra");
                  }}
                  onBlur={() => {
                    onBlurHandler("hra");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  // disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.education_allowance}
                  errorText={errorData?.education_allowance}
                  label={"Education Allowance"}
                  value={form?.education_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "education_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("education_allowance");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.special_allowance}
                  errorText={errorData?.special_allowance}
                  label={"Special Allowance"}
                  value={form?.special_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "special_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("special_allowance");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"}>
              <TotalSum
                firstName="Total Earnings 1: "
                firstAmount={getSumValue(form?.earning_one)}
              />
            </div>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>Part B - Earnings 2</div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_pug}
                  errorText={errorData?.is_pug}
                  label={"Professional Upgradation Applicable"}
                  value={form?.is_pug}
                  handleChange={(value) => {
                    changeTextData(value, "is_pug");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_pug_manual === "NO" ? true : false
                    }
                    type={"number"}
                    isError={errorData?.pug}
                    errorText={errorData?.pug}
                    label={"Professional Upgradation"}
                    value={form?.pug}
                    onTextChange={(text) => {
                      changeTextData(text, "pug");
                    }}
                    onBlur={() => {
                      onBlurHandler("pug");
                    }}
                  />
                  {/* {form?.is_pug_manual == "NO" && ( */}
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_pug_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_pug_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_helper}
                  errorText={errorData?.is_helper}
                  label={"Helper Allowance Applicable"}
                  value={form?.is_helper}
                  handleChange={(value) => {
                    changeTextData(value, "is_helper");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_helper_manual === "NO" ? true : false
                    }
                    type={"number"}
                    isError={errorData?.helper}
                    errorText={errorData?.helper}
                    label={"Helper Allowance"}
                    value={form?.helper}
                    onTextChange={(text) => {
                      changeTextData(text, "helper");
                    }}
                    onBlur={() => {
                      onBlurHandler("helper");
                    }}
                  />
                  {/* {form?.is_helper_manual == "NO" && ( */}
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      disabled={empFlag ? true : false}
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      onClick={() => {
                        changeTextData("YES", "is_helper_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      disabled={empFlag ? true : false}
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      onClick={() => {
                        changeTextData("NO", "is_helper_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_food_coupons}
                  errorText={errorData?.is_food_coupons}
                  label={"Food Coupons Applicable"}
                  value={form?.is_food_coupons}
                  handleChange={(value) => {
                    changeTextData(value, "is_food_coupons");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_food_coupons_manual === "NO"
                        ? true
                        : false
                    }
                    type={"number"}
                    isError={errorData?.food_coupons}
                    errorText={errorData?.food_coupons}
                    label={"Food Coupons"}
                    value={form?.food_coupons}
                    onTextChange={(text) => {
                      changeTextData(text, "food_coupons");
                    }}
                    onBlur={() => {
                      onBlurHandler("food_coupons");
                    }}
                  />
                  {/* {form?.is_food_coupons_manual == "NO" && ( */}
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      disabled={empFlag ? true : false}
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      onClick={() => {
                        changeTextData("YES", "is_food_coupons_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      disabled={empFlag ? true : false}
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      onClick={() => {
                        changeTextData("NO", "is_food_coupons_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_gift_coupons}
                  errorText={errorData?.is_gift_coupons}
                  label={"Gift Coupons Applicable"}
                  value={form?.is_gift_coupons}
                  handleChange={(value) => {
                    changeTextData(value, "is_gift_coupons");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.gift_coupons}
                  errorText={errorData?.gift_coupons}
                  label={"Gift Coupons"}
                  value={form?.gift_coupons}
                  onTextChange={(text) => {
                    changeTextData(text, "gift_coupons");
                  }}
                  onBlur={() => {
                    onBlurHandler("gift_coupons");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_lta}
                  errorText={errorData?.is_lta}
                  label={"LTA Applicable"}
                  value={form?.is_lta}
                  handleChange={(value) => {
                    changeTextData(value, "is_lta");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.lta}
                  errorText={errorData?.lta}
                  label={"LTA"}
                  value={form?.lta}
                  onTextChange={(text) => {
                    changeTextData(text, "lta");
                  }}
                  onBlur={() => {
                    onBlurHandler("lta");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_super_annuation}
                  errorText={errorData?.is_super_annuation}
                  label={"Superannuation Applicable"}
                  value={form?.is_super_annuation}
                  handleChange={(value) => {
                    changeTextData(value, "is_super_annuation");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>

              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.super_annuation}
                  errorText={errorData?.super_annuation}
                  label={"Superannuation"}
                  value={form?.super_annuation}
                  onTextChange={(text) => {
                    changeTextData(text, "super_annuation");
                  }}
                  onBlur={() => {
                    onBlurHandler("super_annuation");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_nps}
                  errorText={errorData?.is_nps}
                  label={"NPS Applicable"}
                  value={form?.is_nps}
                  handleChange={(value) => {
                    changeTextData(value, "is_nps");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.nps}
                  errorText={errorData?.nps}
                  label={"NPS"}
                  value={form?.nps}
                  onTextChange={(text) => {
                    changeTextData(text, "nps");
                  }}
                  onBlur={() => {
                    onBlurHandler("nps");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_em_pf}
                  errorText={errorData?.is_em_pf}
                  label={"Em PF- Deduction Part Applicable"}
                  value={form?.is_em_pf}
                  handleChange={(value) => {
                    changeTextData(value, "is_em_pf");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.earning2_vpf}
                  errorText={errorData?.earning2_vpf}
                  label={"VPF"}
                  value={form?.earning2_vpf}
                  onTextChange={(text) => {
                    changeTextData(text, "earning2_vpf");
                  }}
                  onBlur={() => {
                    onBlurHandler("earning2_vpf");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.vehicle_emi}
                  errorText={errorData?.vehicle_emi}
                  label={"Vehicle EMIs (CTC)"}
                  value={form?.vehicle_emi}
                  onTextChange={(text) => {
                    changeTextData(text, "vehicle_emi");
                  }}
                  onBlur={() => {
                    onBlurHandler("vehicle_emi");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.vehicle_maintenance}
                  errorText={errorData?.vehicle_maintenance}
                  label={"Vehicle Maint (CTC)"}
                  value={form?.vehicle_maintenance}
                  onTextChange={(text) => {
                    changeTextData(text, "vehicle_maintenance");
                  }}
                  onBlur={() => {
                    onBlurHandler("vehicle_maintenance");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.fuel}
                  errorText={errorData?.fuel}
                  label={"Fuel Availed (CTC)"}
                  value={form?.fuel}
                  onTextChange={(text) => {
                    changeTextData(text, "fuel");
                  }}
                  onBlur={() => {
                    onBlurHandler("fuel");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.driver_salary}
                  errorText={errorData?.driver_salary}
                  label={"Driver Salary"}
                  value={form?.driver_salary}
                  onTextChange={(text) => {
                    changeTextData(text, "driver_salary");
                  }}
                  onBlur={() => {
                    onBlurHandler("driver_salary");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.uniform_allowance}
                  errorText={errorData?.uniform_allowance}
                  label={"Uniform Allowance"}
                  value={form?.uniform_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "uniform_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("uniform_allowance");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.telecom_allowance}
                  errorText={errorData?.telecom_allowance}
                  label={"Telecom Allowance"}
                  value={form?.telecom_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "telecom_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("telecom_allowance");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_gti}
                  errorText={errorData?.is_gti}
                  label={"Is GTI?"}
                  value={form?.is_gti}
                  handleChange={(value) => {
                    changeTextData(value, "is_gti");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_gti_manual === "NO" ? true : false
                    }
                    // disabled={true}
                    type={"number"}
                    isError={errorData?.gti}
                    errorText={errorData?.gti}
                    label={"GTI"}
                    value={form?.gti}
                    onTextChange={(text) => {
                      changeTextData(text, "gti");
                    }}
                    onBlur={() => {
                      onBlurHandler("gti");
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_gti_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_gti_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_gmc}
                  errorText={errorData?.is_gmc}
                  label={"Is Gmc?"}
                  value={form?.is_gmc}
                  handleChange={(value) => {
                    changeTextData(value, "is_gmc");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_gmc_manual === "NO" ? true : false
                    }
                    type={"number"}
                    isError={errorData?.gmc}
                    errorText={errorData?.gmc}
                    label={"GMC"}
                    value={form?.gmc}
                    onTextChange={(text) => {
                      changeTextData(text, "gmc");
                    }}
                    onBlur={() => {
                      onBlurHandler("gmc");
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_gmc_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_gmc_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.stat_bonus}
                  errorText={errorData?.stat_bonus}
                  label={"Stat Bonus"}
                  value={form?.stat_bonus}
                  onTextChange={(text) => {
                    changeTextData(text, "stat_bonus");
                  }}
                  onBlur={() => {
                    onBlurHandler("stat_bonus");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className={"formGroup"}></div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <TotalSum
                firstName="Total Earning2: "
                firstAmount={getSumValue(form?.earning_two)}
                secondName="Gross Salary (Part A + Part B) :"
                secondAmount={getSumValue(form?.gross_component)}
              />
            </div>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>Part C - Earning 3</div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.earning_three_pli}
                  errorText={errorData?.earning_three_pli}
                  label={"PLI - Qtrly"}
                  value={form?.earning_three_pli}
                  onTextChange={(text) => {
                    changeTextData(text, "earning_three_pli");
                  }}
                  onBlur={() => {
                    onBlurHandler("earning_three_pli");
                  }}
                />
              </div>
              <div className={"formGroup"}></div>
            </div>
            {/* <div className={"formFlex"}>
                  <TotalSum
                    firstName="Incremental Gross Salary + Car Component: "
                    firstAmount={form?.earning_three_pli}
                  />
                </div> */}
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>Part D - Deduction 1</div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_deduction_vpf}
                  errorText={errorData?.is_deduction_vpf}
                  label={"VPF Applicable"}
                  value={form?.is_deduction_vpf}
                  handleChange={(value) => {
                    changeTextData(value, "is_deduction_vpf");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={
                    empFlag || form?.is_deduction_vpf == "NO" ? true : false
                  }
                  type={"number"}
                  isError={errorData?.deduction_vpf_pct}
                  errorText={errorData?.deduction_vpf_pct}
                  label={"VPF Percentage"}
                  value={form?.deduction_vpf_pct}
                  onTextChange={(text) => {
                    changeTextData(text, "deduction_vpf_pct");
                  }}
                  onBlur={() => {
                    onBlurHandler("deduction_vpf_pct");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.deduction_vpf}
                  errorText={errorData?.deduction_vpf}
                  label={"VPF"}
                  value={form?.deduction_vpf}
                  onTextChange={(text) => {
                    changeTextData(text, "deduction_vpf");
                  }}
                  onBlur={() => {
                    onBlurHandler("deduction_vpf");
                  }}
                />
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_em_esi}
                  errorText={errorData?.is_em_esi}
                  label={"Em ESI- Deduction Part Applicable"}
                  value={form?.is_em_esi}
                  handleChange={(value) => {
                    changeTextData(value, "is_em_esi");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>

              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_em_esi_manual === "NO" ? true : false
                    }
                    // disabled={true}
                    type={"number"}
                    isError={errorData?.em_esi}
                    errorText={errorData?.em_esi}
                    label={"Em ESI- Deduction Part"}
                    value={form?.em_esi}
                    onTextChange={(text) => {
                      changeTextData(text, "em_esi");
                    }}
                    onBlur={() => {
                      onBlurHandler("em_esi");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_em_esi_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_em_esi_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.em_lwf}
                  errorText={errorData?.em_lwf}
                  label={"Em LWF"}
                  value={form?.em_lwf}
                  onTextChange={(text) => {
                    changeTextData(text, "em_lwf");
                  }}
                  onBlur={() => {
                    onBlurHandler("em_lwf");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.is_eligible_pf_contribution}
                  errorText={errorData?.is_eligible_pf_contribution}
                  label={"PF Contribution?"}
                  value={form?.is_eligible_pf_contribution}
                  handleChange={(value) => {
                    changeTextData(value, "is_eligible_pf_contribution");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_em_pf_manual === "NO" ? true : false
                    }
                    // disabled={true}
                    type={"number"}
                    isError={errorData?.em_pf}
                    errorText={errorData?.em_pf}
                    label={"Em PF- Deduction Part"}
                    value={form?.em_pf}
                    onTextChange={(text) => {
                      changeTextData(text, "em_pf");
                    }}
                    onBlur={() => {
                      onBlurHandler("em_pf");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_em_pf_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_em_pf_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.freeze_pension}
                  errorText={errorData?.freeze_pension}
                  label={"Freeze Pension?"}
                  value={form?.freeze_pension}
                  handleChange={(value) => {
                    changeTextData(value, "freeze_pension");
                  }}
                >
                  <MenuItem value={"YES"}>Yes</MenuItem>
                  <MenuItem value={"NO"}>No</MenuItem>
                </CustomSelectField>
              </div>
              <div className={"formGroup"}></div>
            </div>
            <div className={"formFlex"}>
              <TotalSum
                customClass={styles.redField}
                firstName="Total Deduction 1:  "
                firstAmount={getSumValue(form?.total_deduction)}
              />
            </div>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>
                  Part E (Statutory Components of CTC Paid by Employer) - Earning 4
                </div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_er_pf_manual === "NO" ? true : false
                    }
                    // disabled={true}
                    type={"number"}
                    isError={errorData?.er_pf}
                    errorText={errorData?.er_pf}
                    label={"PF - Er Contribution Part"}
                    value={form?.er_pf}
                    onTextChange={(text) => {
                      changeTextData(text, "er_pf");
                    }}
                    onBlur={() => {
                      onBlurHandler("er_pf");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_er_pf_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_er_pf_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_er_esi_manual === "NO" ? true : false
                    }
                    type={"number"}
                    isError={errorData?.er_esi}
                    errorText={errorData?.er_esi}
                    label={"ESI - Er Contribution Part"}
                    value={form?.er_esi}
                    onTextChange={(text) => {
                      changeTextData(text, "er_esi");
                    }}
                    onBlur={() => {
                      onBlurHandler("er_esi");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_er_esi_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_er_esi_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  type={"number"}
                  isError={errorData?.er_lwf}
                  errorText={errorData?.er_lwf}
                  label={"Er LWF"}
                  value={form?.er_lwf}
                  onTextChange={(text) => {
                    changeTextData(text, "er_lwf");
                  }}
                  onBlur={() => {
                    onBlurHandler("er_lwf");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                {/* <div style={{ display: "flex" }}>
                      <CustomTextField
                        disabled={
                          form?.is_gratuity_manual === "NO" ? true : false
                        }
                        type={"number"}
                        isError={errorData?.gratuity}
                        errorText={errorData?.gratuity}
                        label={"Gratuity"}
                        value={form?.gratuity}
                        onTextChange={(text) => {
                          changeTextData(text, "gratuity");
                        }}
                        onBlur={() => {
                          onBlurHandler("gratuity");
                        }}
                      />
                      <div className={styles.editBtnWrap}>
                        <IconButton
                          className={"tableActionBtnEdit"}
                          color="secondary"
                          
                          onClick={() => {
                            changeTextData("YES", "is_gratuity_manual");
                          }}
                        >
                          <Edit fontSize={"small"} />
                        </IconButton>
                      </div>
                      <div className={styles.editBtnWrap}>
                        <IconButton
                          className={"tableActionBtnEdit"}
                          color="secondary"
                          
                          onClick={() => {
                            changeTextData("NO", "is_gratuity_manual");
                          }}
                        >
                          <Delete fontSize={"small"} />
                        </IconButton>
                      </div>
                    </div> */}
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <TotalSum
                firstName="Total Earnings 4 :"
                firstAmount={getSumValue(form?.earning_four)}
              />
            </div>
            <div className={"headerFlex"}>
              <h4 className={"infoTitle"}>
                <div className={"heading"}>
                  Part E (Organizational Components of CTC) - Earning 5
                </div>
              </h4>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      empFlag || form?.is_gratuity_manual === "NO" ? true : false
                    }
                    type={"number"}
                    isError={errorData?.gratuity}
                    errorText={errorData?.gratuity}
                    label={"Gratuity"}
                    value={form?.gratuity}
                    onTextChange={(text) => {
                      changeTextData(text, "gratuity");
                    }}
                    onBlur={() => {
                      onBlurHandler("gratuity");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_gratuity_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_gratuity_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={true}
                  type={"number"}
                  isError={errorData?.annual_bonus}
                  errorText={errorData?.annual_bonus}
                  label={"Bonus"}
                  value={form?.annual_bonus}
                  onTextChange={(text) => {
                    changeTextData(text, "annual_bonus");
                  }}
                  onBlur={() => {
                    onBlurHandler("annual_bonus");
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                {/* <CustomTextField
                      // disabled={true}
                      type={"number"}
                      
                      isError={errorData?.insurance}
                      errorText={errorData?.insurance}
                      label={"Medical Insurance Premium"}
                      value={form?.insurance}
                      onTextChange={(text) => {
                        changeTextData(text, "insurance");
                      }}
                      onBlur={() => {
                        onBlurHandler("insurance");
                      }}
                    /> */}
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.stability_incentive}
                  errorText={errorData?.stability_incentive}
                  label={"Stability Allowance"}
                  value={form?.stability_incentive}
                  onTextChange={(text) => {
                    changeTextData(text, "stability_incentive");
                  }}
                  onBlur={() => {
                    onBlurHandler("stability_incentive");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.stability_terms}
                  errorText={errorData?.stability_terms}
                  label={"Stability Allowance Payment term"}
                  value={form?.stability_terms}
                  handleChange={(value) => {
                    changeTextData(value, "stability_terms");
                  }}
                >
                  <MenuItem value={"NONE"}>None</MenuItem>
                  <MenuItem value={"QUARTERLY"}>Quarterly</MenuItem>
                  <MenuItem value={"MONTHLY"}>Monthly</MenuItem>
                  <MenuItem value={"SPECIAL"}>Special Arrangement</MenuItem>
                </CustomSelectField>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.retention_allowance}
                  errorText={errorData?.retention_allowance}
                  label={"Retention Allowance"}
                  value={form?.retention_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "retention_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("retention_allowance");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.retention_terms}
                  errorText={errorData?.retention_terms}
                  label={"Retention Allowance Payment term"}
                  value={form?.retention_terms}
                  handleChange={(value) => {
                    changeTextData(value, "retention_terms");
                  }}
                >
                  <MenuItem value={"NONE"}>None</MenuItem>
                  <MenuItem value={"QUARTERLY"}>Quarterly</MenuItem>
                  <MenuItem value={"MONTHLY"}>Monthly</MenuItem>
                  <MenuItem value={"SPECIAL"}>Special Arrangement</MenuItem>
                </CustomSelectField>
              </div>
            </div>
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.perf_bonus}
                  errorText={errorData?.perf_bonus}
                  label={"Performance Allowance"}
                  value={form?.perf_bonus}
                  onTextChange={(text) => {
                    changeTextData(text, "perf_bonus");
                  }}
                  onBlur={() => {
                    onBlurHandler("perf_bonus");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.performance_terms}
                  errorText={errorData?.performance_terms}
                  label={"Performance Allowance Payment term"}
                  value={form?.performance_terms}
                  handleChange={(value) => {
                    changeTextData(value, "performance_terms");
                  }}
                >
                  <MenuItem value={"NONE"}>None</MenuItem>
                  <MenuItem value={"QUARTERLY"}>Quarterly</MenuItem>
                  <MenuItem value={"MONTHLY"}>Monthly</MenuItem>
                  <MenuItem value={"SPECIAL"}>Special Arrangement</MenuItem>
                </CustomSelectField>
              </div>
            </div>{" "}
            <div className={"formFlex"} id={styles.mobileResponsiveData}>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      form?.vehicle_maintenance ||
                      form?.fuel ||
                      (empFlag || form?.is_two_car_maintenance_manual === "NO"
                        ? true
                        : false)
                    }
                    type={"number"}
                    isError={errorData?.two_car_maintenance}
                    errorText={errorData?.two_car_maintenance}
                    label={"Type II Car Maint"}
                    value={form?.two_car_maintenance}
                    onTextChange={(text) => {
                      changeTextData(text, "two_car_maintenance");
                    }}
                    onBlur={() => {
                      onBlurHandler("two_car_maintenance");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_two_car_maintenance_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_two_car_maintenance_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
              <div className={"formGroup"}>
                <div style={{ display: "flex" }}>
                  <CustomTextField
                    disabled={
                      form?.vehicle_maintenance ||
                      form?.fuel ||
                      (empFlag || form?.is_two_fuel_manual === "NO" ? true : false)
                    }
                    //  disabled={empFlag || form?.is_two_fuel_manual === "NO" ? true : false}
                    type={"number"}
                    isError={errorData?.two_fuel}
                    errorText={errorData?.two_fuel}
                    label={"Type II Fuel"}
                    value={form?.two_fuel}
                    onTextChange={(text) => {
                      changeTextData(text, "two_fuel");
                    }}
                    onBlur={() => {
                      onBlurHandler("two_fuel");
                    }}
                  />
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("YES", "is_two_fuel_manual");
                      }}
                    >
                      <Edit fontSize={"small"} />
                    </IconButton>
                  </div>
                  <div className={styles.editBtnWrap}>
                    <IconButton
                      className={"tableActionBtnEdit"}
                      color="secondary"
                      disabled={empFlag ? true : false}
                      onClick={() => {
                        changeTextData("NO", "is_two_fuel_manual");
                      }}
                    >
                      <Delete fontSize={"small"} />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={"formFlex"}>
              <div className={"formGroup"}>
                <CustomTextField
                  disabled={empFlag ? true : false}
                  type={"number"}
                  isError={errorData?.deputation_allowance}
                  errorText={errorData?.deputation_allowance}
                  label={"Deputation/City Allowance"}
                  value={form?.deputation_allowance}
                  onTextChange={(text) => {
                    changeTextData(text, "deputation_allowance");
                  }}
                  onBlur={() => {
                    onBlurHandler("deputation_allowance");
                  }}
                />
              </div>
              <div className={"formGroup"}>
                <CustomSelectField
                  disabled={empFlag ? true : false}
                  isError={errorData?.deputation_terms}
                  errorText={errorData?.deputation_terms}
                  label={"Deputation Allowance Payment term"}
                  value={form?.deputation_terms}
                  handleChange={(value) => {
                    changeTextData(value, "deputation_terms");
                  }}
                >
                  <MenuItem value={"NONE"}>None</MenuItem>
                  <MenuItem value={"QUARTERLY"}>Quarterly</MenuItem>
                  <MenuItem value={"MONTHLY"}>Monthly</MenuItem>
                  <MenuItem value={"SPECIAL"}>Special Arrangement</MenuItem>
                </CustomSelectField>
              </div>
            </div>
            <div className={styles.bgGreen}>
              <div style={{ marginLeft: "15px" }}>
                Net Composite CTC (Earning 1 + Earning 2 + Earning 3 + Earning 4 +
                Earning 5)
              </div>
              <div style={{ marginRight: "10px" }}>₹ {form?.monthly_ctc}</div>
            </div>
            <div className={"formFlex"}>
              <TotalSum
                firstName="Total Earnings 5: "
                firstAmount={getSumValue(form?.earning_five)}
                secondName="Net Pay :"
                secondAmount={getSumValue(form?.net_pay)}
              />
            </div>
          </div>
        </>
      )}

      {showExtraFields && (
        <>
          <div className={"plainPaper"}>
            <div className={"headerFlex wrapper"} id={styles.wrapperValueData}>
              <div className={"infoTitle inner"}></div>
              <ButtonBase
                type={"button"}
                className={styles.createBtn}
                onClick={handleProfileView}
              >
                PREVIEW SALARY STRUCTURE
              </ButtonBase>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SalaryCalculator;
